import axios from "axios";
import Config from "../utils/Config";
import Middleware from "./Middleware";

class CompanySettingsService {
    config = {
        headers: {
            Authorization: "",
            CompanyId: "",
        },
    };

    //set access token
    setAccessToken(accessToken, companyId) {
        this.config.headers.Authorization = accessToken;
        this.config.headers.CompanyId = companyId;
    }

    //get user profile by user detail id
    async getCompanySettingsByUserDetailsId (userDetailsId, companyId, accessToken){
        this.setAccessToken(accessToken, companyId);
        const res = await Middleware.api.get(
            `/api/company/id`,
            this.config
        )
        return res.data;
    }

    //update company settings
    async updateCompanySettings(formData, userDetailsId, companyId, accessToken) {
        this.setAccessToken(accessToken, companyId);
        const res = await Middleware.api.put(
            `/api/company/updateCompanyAndConfig`,
            formData,
            this.config
        )
        return res.data;
    }
};

export default new CompanySettingsService();